// extracted by mini-css-extract-plugin
module.exports = {"pageBtn":"pageitem_pageBtn__H5e5O","xs":"pageitem_xs__3GWzO"};